import { useEffect, useRef } from "react";

const credentials = [
  {
    icon: "ri-medal-line",
    value: "제50회",
    label: "사법시험 합격",
  },
  {
    icon: "ri-briefcase-line",
    value: "제40기",
    label: "사법연수원 수료",
  },
  {
    icon: "ri-graduation-cap-line",
    value: "금융법 석사",
    label: "고려대학교 법무대학원",
  },
  {
    icon: "ri-award-line",
    value: "변리사·세무사",
    label: "전문자격 2종 보유",
  },
];

export default function HeroSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(24px)";
    el.style.transition = "opacity 0.8s ease-out, transform 0.8s ease-out";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      });
    });
  }, []);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] lg:min-h-[800px] flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src="/images/bg.webp"
          alt="법률 전문 배경"
          className="w-full h-full object-cover object-[55%_center] md:object-center"
        />
      </div>

      <div
        ref={sectionRef}
        className="relative z-10 w-full px-4 md:px-8 lg:px-16 py-24 md:py-32"
      >
        <div className="flex flex-col lg:flex-row items-center lg:items-end justify-center gap-32 lg:gap-56 max-w-[1400px] mx-auto">
          <div className="text-center lg:text-left self-center">
            <div className="mb-6">
              <img
                src="/images/logo1.webp"
                alt="법무법인 효민"
                className="h-12 md:h-16 w-auto mx-auto lg:mx-0 brightness-0 invert opacity-90"
              />
            </div>

            <p className="inline-flex items-center gap-2 px-4 py-1.5 bg-[oklch(0.78_0.17_100)]/15 border border-[oklch(0.84_0.13_100)]/25 rounded-full text-[oklch(0.84_0.13_100)] text-sm md:text-base font-medium tracking-widest mb-3 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-[oklch(0.84_0.13_100)]" />
              부동산·형사전문변호사
            </p>

            <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              이승환 <span className="text-[oklch(0.84_0.13_100)]">변호사</span>
            </h1>

            <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              다양한 사건 해결 경험을 통해 쌓은 노하우와 실력으로<br className="hidden md:block" />
              어려움에 처한 의뢰인들에게 희망의 사다리가 되겠습니다
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="tel:02-3471-3690"
                className="flex w-full sm:w-auto flex-1 items-center justify-center gap-2 px-6 py-3 bg-[oklch(0.78_0.17_100)] hover:bg-[oklch(0.70_0.16_100)] text-foreground-950 font-semibold rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg" />
                <span>02-3471-3690</span>
              </a>
              <a
                href="https://m.booking.naver.com/booking/6/bizes/216261/items/2986580?area=pll&lang=ko&startDate=2026-08-13&theme=place"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full sm:w-auto flex-1 items-center justify-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-md transition-colors border border-white/20 whitespace-nowrap"
              >
                <i className="ri-calendar-check-line text-lg" />
                <span>상담예약</span>
              </a>
            </div>

          </div>

          <div className="shrink-0 hidden md:block">
            <div className="relative">
              <div className="relative w-[300px] md:w-[380px] lg:w-[450px] h-[400px] md:h-[480px] lg:h-[560px] rounded-2xl border border-white/15 bg-white/10 backdrop-blur-sm p-2 md:p-2.5 overflow-hidden">
                <div className="relative w-full h-full overflow-hidden rounded-xl">
                  <img
                    src="/images/pro_w.webp"
                    alt="이승환 변호사"
                    className="absolute left-1/2 -translate-x-1/2 ml-2 md:ml-3 lg:ml-4 -bottom-14 md:-bottom-20 lg:-bottom-24 h-[460px] md:h-[560px] lg:h-[640px] w-auto max-w-none"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent px-4 pt-16 pb-4">
                    <p className="text-white font-semibold text-base md:text-lg leading-tight whitespace-nowrap">
                      이승환 변호사
                    </p>
                    <p className="text-[oklch(0.84_0.13_100)] text-xs tracking-widest mt-1 whitespace-nowrap">
                      부동산 · 형사전문
                    </p>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[oklch(0.78_0.17_100)]/20 rounded-full blur-3xl" />
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-500/20 rounded-full blur-2xl" />
              <div className="absolute bottom-2 right-2 md:bottom-3 md:right-3 lg:bottom-4 lg:right-4 flex items-center gap-2">
                <img
                  src="/images/law_d.webp"
                  alt="형사법 전문등록증서"
                  className="h-32 md:h-40 lg:h-44 w-auto object-contain"
                />
                <img
                  src="/images/law_s.webp"
                  alt="부동산 전문등록증서"
                  className="h-32 md:h-40 lg:h-44 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Floating credentials bar — straddles the hero boundary */}
        <div className="absolute bottom-0 left-0 right-0 z-20 translate-y-[70%] md:translate-y-1/2 flex justify-center px-4 md:px-8 lg:px-16 pointer-events-none">
          <div className="w-full max-w-[1400px] bg-background-50 rounded-2xl border border-background-200 px-6 md:px-8 py-5 md:py-6 shadow-sm pointer-events-auto">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-2 lg:gap-y-0">
                {credentials.map((cred, idx) => (
                  <div
                    key={cred.value}
                    className={`flex items-center justify-start gap-2 px-2 lg:px-3 ${idx > 0 ? "lg:border-l border-background-200" : ""}`}
                  >
                    <span className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center shrink-0">
                      <i className={`${cred.icon} text-foreground-700 text-base`} />
                    </span>
                    <div className="min-w-0">
                      <p className="font-display font-bold text-foreground-950 text-sm md:text-base leading-tight whitespace-nowrap">
                        {cred.value}
                      </p>
                      <p className="text-xs text-foreground-600 leading-snug mt-0.5">
                        {cred.label}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}